import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const FORM_URL = 'https://readdy.ai/api/form/d8uk21du37m8lq7g36bg';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setSubmitted(true);
      return;
    }
    const formData = new FormData(form);
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
      setEmail('');
    }
  };

  const halfLen = Math.ceil(categories.length / 2);
  const leftCats = categories.slice(0, halfLen);
  const rightCats = categories.slice(halfLen);

  return (
    <footer className="bg-foreground-900 text-background-50 rounded-t-3xl mt-20">
      <div className="px-4 md:px-6 py-14 md:py-20 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-3">
            <h3 className="font-label text-3xl md:text-4xl font-bold mb-6">Start Here</h3>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                allchinabuy sheet
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold border border-background-300/30 text-background-50 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-shopping-bag-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">Categories</h4>
            <div className="space-y-2.5">
              {leftCats.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">&nbsp;</h4>
            <div className="space-y-2.5">
              {rightCats.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">Guides &amp; Quick Links</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Home
              </Link>
              <Link to="/article/allchinabuy-spreadsheet-complete-guide" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Complete Guide
              </Link>
              <Link to="/article/allchinabuy-spreadsheet-safety-tips" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Safety Tips
              </Link>
              <Link to="/article/allchinabuy-spreadsheet-shipping-guide" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Shipping Guide
              </Link>
              <Link to="/article/beginner-first-purchase-allchinabuy-spreadsheet" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Beginner Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Main Website
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-sm font-semibold text-background-400 uppercase tracking-wider mb-4">Newsletter</h4>
            <p className="text-sm text-background-300 mb-4">Get the latest spreadsheet updates and new finds delivered to your inbox.</p>
            {submitted ? (
              <p className="text-sm text-primary-400 font-medium">Thanks for subscribing! Check your inbox.</p>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form="">
                <input
                  type="text"
                  name="website_alt"
                  autoComplete="off"
                  tabIndex={-1}
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="email"
                    name="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="flex-1 px-4 py-2.5 text-sm bg-foreground-800/50 border border-background-300/20 rounded-full text-background-50 placeholder:text-background-500 focus:outline-none focus:border-primary-500/50 transition-colors"
                  />
                  <button
                    type="submit"
                    className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full hover:bg-primary-600 transition-all flex-shrink-0 cursor-pointer"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background-300/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} AllChinaBuySpreadsheet. All rights reserved. This is an informational site.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
                Privacy
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-8 px-4 overflow-hidden select-none pointer-events-none">
        <p className="font-heading text-[10vw] md:text-8xl font-bold text-foreground-800/10 leading-none tracking-tighter text-center whitespace-nowrap">
          ALLCHINABUYSPREADSHEET
        </p>
      </div>
    </footer>
  );
}